import { BaseFormComponent, DatasetFormData } from 'src/app/@shared/form/base-form.component';
import { Component, Input, inject } from '@angular/core';
import { PersonModel } from 'src/app/person/@shared/person.model';
import { PersonService } from 'src/app/person/@shared/person.service';
import { personNameValidator } from 'src/app/@shared/person-name.validator';

@Component({
  selector: 'person-form',
  standalone: false,
  styleUrls: ['./person-form.component.scss'],
  templateUrl: './person-form.component.html',
})
export class PersonFormComponent extends BaseFormComponent<PersonModel> {
  @Input() public isEditMode: boolean;

  protected personService = inject(PersonService);

  protected prepareForm(): void {
    super.prepareForm();
    this.editForm.addValidators(personNameValidator);
  }

  protected onDataReceived(data: PersonModel): void {
    this.datasetData = {
      ...data,
    };

    this.prepareForm();
    this.patchFormByDataset(this.datasetData);
  }

  protected async handleRequest(formData: DatasetFormData): Promise<boolean> {
    if (this.isEditMode) {
      return !!await this.personService.patch(this.datasetData.id, formData);
    }

    const normalizedFormData = {
      ...formData,
      firstName: formData.firstName ?? '',
      lastName: formData.lastName ?? '',
    };

    return !!await this.personService.create(normalizedFormData, 'persons');
  }
}
